import React from 'react'

import { Spin } from 'antd'
import { branch, renderComponent } from 'recompose'

import './spinner.css'

export const Spinner = () => (
  <div className="spinner">
    {' '}
    <Spin />{' '}
  </div>
)

export const spinnerWhileLoading = (isLoading) => branch(isLoading, renderComponent(Spinner))



// WEBPACK FOOTER //
// ./src/components/higher-order/spinner.tsx